import request from '@/utils/axios.js'

// 按活动id获取关联的优惠券列表
export function getCouponList (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/coupon-list',
    method: 'post',
    data: data
  })
}

// 用户领用优惠券大礼包（直接领取活动）
export function batchGet (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/grant/package',
    method: 'post',
    data: data
  })
}
